module.exports = __webpack_public_path__ + "static/img/QB1000.1984151.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QB1000.png
// module id = Q4GL
// module chunks = 2